import React from 'react';
import timezones from './timezones.json';
import { Select3 } from '@weezevent/nacre';

export function TimeZoneSelect({ value, onChange, ...rest }) {
    let options = React.useMemo(() => timezones.map(v => ({ text: v, value: v })), [timezones]);
    return (
        <div style={{ display: 'inline-block', width: 180 }}>
            <Select3 value={value} options={options} onChange={onChange} {...rest} />
        </div>
    );
}
